'use client';

import { Google } from '@ahamove/icons';
import { Box, Button, Space, rem } from '@mantine/core';
import { GoogleLogin } from '@react-oauth/google';
import { useCallback } from 'react';
import { useAuth } from '../auth-provider';
import { authLocales, createTranslations, type Locales } from '../locales';
import { useAuthStore } from '../store/auth-store-provider';

type Props = {
  lang?: keyof Locales;
};
export default function GoogleLoginBtn({ lang = 'vi' }: Props) {
  const tAuth = createTranslations({ locales: authLocales, lang });

  const { googleClientId } = useAuthStore((state) => state);

  const { loginViaSocial } = useAuth();

  const handleClickGgLoginBtn = useCallback(() => {
    const wrap = document.querySelector('#wrap-google-login-button');
    if (!wrap) return;
    const button = wrap.querySelectorAll('[role="button"]');
    if (button.length && button[0]) {
      (button[0] as HTMLButtonElement).click();
    }
  }, []);

  if (!googleClientId) {
    return null;
  }

  return (
    <>
      <Button
        type="button"
        px="md"
        h={rem(44)}
        fullWidth
        variant="light"
        color="neutral"
        c="neutral.6"
        onClick={handleClickGgLoginBtn}
        leftSection={<Google width={24} height={24} />}
        rightSection={<Space w={24} />}
        justify="space-between"
        styles={{
          section: {
            flex: 'none',
          },
          label: {
            width: '100%',
            justifyContent: 'center',
          },
        }}
      >
        {tAuth('loginWithGoogle')}
      </Button>
      <Box id="wrap-google-login-button" display="none">
        <GoogleLogin
          useOneTap
          cancel_on_tap_outside={false}
          onSuccess={(res) => {
            loginViaSocial(res, 'google');
          }}
          onError={() => {
            console.log('cannot load Google');
          }}
        />
      </Box>
    </>
  );
}
